// extracted by mini-css-extract-plugin
module.exports = {"container":"CartForm_container__1nzfO","buttonsWrapper":"CartForm_buttonsWrapper__1iy-D","title":"CartForm_title__aLdbb","cancelBtn":"CartForm_cancelBtn__3-ocP"};